<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">添加教育经历</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">学校名称</p>
        <p> <input class="inforNameInput" v-model="data.name" type="text" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">学历</p>
        <p><input class="inforNameInput" v-model="data.education"  type="text" placeholder="请填写" ></p>
      </div>
      <div class="inforSix">
        <!--<p>  <van-field label="出生日期"  readonly /></p>-->
        <van-cell-group >
          <van-field label="是否统招"  readonly />
          <!--&lt;!&ndash;<van-field   placeholder="1994.03" />&ndash;&gt;-->
        </van-cell-group>
        <van-radio-group v-model="data.istongzhao"  direction="horizontal">
          <van-radio name="1">统招</van-radio>
          <van-radio name="2">非统招</van-radio>
        </van-radio-group>
      </div>
      <!--<div class="inforName">-->
      <!--<p class="inforNameTop">专业名称</p>-->
      <!--<p style="display: flex"><input class="inforTime" type="text" value="2014.08"><span>&#45;&#45;</span><input class="inforTime" type="text" value="2015.09"></p>-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">专业名称</p>
        <p><input class="inforNameInput" v-model="data.major"  type="text" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">在校时间</p>
        <p style="display: flex">
          <input class="inforTime" v-model="data.schoolstart"  type="text" >
          <span>--</span>
          <input class="inforTime" v-model="data.schoolend"  type="text"></p>
      </div>

    </div>
    <div class="button">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addResumer()">保存</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        radio:"1",
        data:{
          name:'',
          education:"",
          istongzhao:"",
          major:"",
          schoolstart:'',
          schoolend:"",
        }
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
     addResumer(){
    this.$api.addResume({
      "data[name]": this.data.name,
      "data[education]": 1,
      "data[istongzhao]":this.data.istongzhao,
      "data[major]": this.data.major,
      "data[schoolstart]": this.data.schoolstart,
      "data[schoolend]": this.data.schoolend,
      "data[resumeid]":this.$route.params.id
    })
      .then(res=>{
        if(res.status==200){
          this.data=res.data
          this.id=res.data.id
          console.log(this.data)
        }
      })
     }
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  .inforSix{
    display: flex;
    /*width: 90%;*/
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  .van-cell-group{
    width: 50%;
  }
  .van-cell{
    padding: 10px 0px;
  }
  .button{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/addEducation.vue